// ============================================================
// Feature flags — launch-gated capabilities.
// ------------------------------------------------------------
// Toggle these to enable/disable features without removing code.
// Disabled features keep their full implementation intact
// (components, API calls, types, routes) so they can be
// re-enabled by simply flipping the flag back to `true`.
// ============================================================

export const FEATURE_FLAGS = {
  /**
   * Advertising / Promoted listings.
   *
   * When `false`:
   *   • The "Promoted" sponsored strip on the customer dashboard is hidden.
   *   • The "Sponsored listings" section on the jobs list is hidden.
   *   • The "Advertising" sidebar nav item (admin/ads route) is hidden
   *     from all roles (admin, provider, merchant).
   *   • The ad-feed and ad-tracking API queries are never fired
   *     (the `useQuery` `enabled` flag short-circuits).
   *
   * Set to `false` again to hide all ad surfaces for a launch.
   * No other code changes are required.
   */
  ADS_ENABLED: true,
} as const;

export type FeatureFlags = typeof FEATURE_FLAGS;
